module.exports = __webpack_public_path__ + "static/media/11@720w.093ececc.jpg";